import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g fill="#FFF" fillRule="evenodd">
      <path
        fillOpacity={0.55}
        d="M3.56 9.84l-1.074 3.303a.731.731 0 00.266.818l9.29 6.75L3.56 9.839zm16.965 0l1.073 3.303a.731.731 0 01-.265.818l-9.29 6.75 8.482-10.872z"
      />
      <path d="M12.042 20.71l3.532-10.87H8.51z" />
      <path fillOpacity={0.8} d="M12.042 20.71L8.51 9.84H3.56z" />
      <path d="M3.56 9.84h4.95L6.382 3.291a.366.366 0 00-.695 0L3.559 9.839z" />
      <path fillOpacity={0.8} d="M12.042 20.71l3.532-10.87h4.95z" />
      <path d="M20.525 9.84h-4.95l2.127-6.548a.366.366 0 01.695 0l2.128 6.547z" />
    </g>
  </svg>
);
